<template>
    <b-card
        bg-variant="dark"
        text-variant="white"
        header-tag="header"
        header-text-variant="white"
        header-bg-variant="dark"
    >
        <div slot="header">
            <i :class="icon"></i> {{ valueLabel }}
        </div>
        <p class="card-text">
            <b-row>
                <b-col cols="7">
                    <b-row>
                        <!-- <b-col cols="12">{{ totalLabel }}: {{ total }}</b-col> -->
                        <b-col cols="12"><i class="fa fa-home" aria-hidden="true"></i> : {{ total }}</b-col>
                    </b-row>
                    <b-row>
                        <!-- <b-col cols="12">Cantidad: {{ value }}</b-col> -->
                        <b-col cols="12"><i class="fa fa-line-chart" aria-hidden="true"></i> : {{ indicatorData.value }}</b-col>
                    </b-row>
                </b-col>
                <b-col class="text-center align-middle" cols="5">
                    <h3><div :class="getStatusColor(indicatorData.status)">{{ indicatorData.indicator | decimal(2) }}</div></h3>
                </b-col>
            </b-row>
        </p>
    </b-card>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    props: ['total', 'indicatorData', 'totalLabel', 'valueLabel', 'icon', 'period'],
    computed: {
        isOpen() {
            return this.period === moment().format('YYYYMM');
        }
    },
    methods: {
        getStatusColor(status) {
            if(this.isOpen) return 'text-info';

            return status? 'text-success': 'text-danger';
        }
    }
    
}
</script>